
export default {
  mounted() {
    this.consoleLogBOLD();
  }
};
